/***********************************************************
Royal Hawaiian Services
Alexander Self
2/6/18
Mech. harvest form: Handles form interactions
***********************************************************/
import React, { Component } from 'react';
import moment from 'moment';
import { DatePicker2, NumberInput, Select, SelectField, SelectBlock, AutoComplete,
  Textarea } from '../../inputs';
import { LOCATIONS, CONTAINER_TYPES, STATUS } from '../../../constants';
import { mapEquipmentForAutoComplete, onDummyComplete,
  mapEmployeeForAutoComplete } from '../../../utils';

class MechanicalHarvestEditForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.id
    }
  }
  render() {
    let max = moment().format('YYYY-MM-DD');
    return (
      <div>
        <form id="mechHarvest-edit-form" onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="col s12 m4 l4 xl4">
              <DatePicker2 id={'mech-edit-date'} label={'Date'} max={max} />
            </div>
            <div className="col s12 m4 l4 xl4">
              <Select id={'mech-edit-location'} opts={LOCATIONS} label={'Location'} onChange={(e) => this.props.fetchFieldsByLoc(e.target.value)} />
            </div>
            <div className="col s12 m4 l4 xl4">
              <SelectField id={'mech-edit-field'} opts={this.props.fields} label={'Field'}
                onChange={(event) => { this.props.fetchBlocksByField(event.target.value, 'mech-field'); this.props.selectField(event.target.value) }} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m4 l4 xl4">
              <SelectBlock id={'mech-edit-block'} label={'Block No.'} opts={this.props.blocks} />
            </div>
            <div className="col s12 m4 l4 xl4">
              <NumberInput id={'mech-edit-treesCovered'} label={'Trees Covered'} />
            </div>
            <div className="col s12 m4 l4 xl4">
              <NumberInput id={'mech-edit-hours'} label={'Total Hours'} step={"0.1"} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m4 l4 xl4">
              <Select id={'mech-edit-containerType'} opts={CONTAINER_TYPES} label={'Container Type'} />
            </div>
            <div className="col s12 m4 l4 xl4">
              <NumberInput id={'mech-edit-containerCount'} label={'Total Containers'} />
            </div>
            <div className="col s12 m4 l4 xl4">
              <NumberInput id={'mech-edit-estLbsPerContainer'} label={'Est. Lbs/Container'} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m4 l4 xl4">
              <AutoComplete id={'mech-edit-equipmentNo'} label={'Equipment No.'}
                data={mapEquipmentForAutoComplete(this.props.equipmentNo)} onComplete={onDummyComplete}  />
            </div>
            <div className="col s12 m4 l4 xl4">
              <AutoComplete id={'mech-edit-employee'} label={'Equipment Operator'}
                data={mapEmployeeForAutoComplete(this.props.employees)}
                onComplete={onDummyComplete}  />
            </div>
            <div className="col s12 m4 l4 xl4">
              <NumberInput id={'mech-edit-round'} label={'Round'} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m8 l8 xl8">
              <Textarea id={'mech-edit-notes'} label={'Notes'} />
            </div>
            <div className="col s12 m4 l4 xl4">
              <Select id={'mech-edit-status'} opts={STATUS} label={'Status'} />
            </div>
          </div>
          <input type="hidden" id="mech-edit-time" value={moment().format("hh:mm:ss a")} />
          <input type="hidden" id="mech-edit-submitter" value={this.props.submitter} />
          <input type="hidden" id="mech-edit-id" value={this.state.id} />
        </form>
      </div>
    )
  }
}

export default MechanicalHarvestEditForm;

/*

*/


/* END */



// WEBPACK FOOTER //
// ./src/components/harvest/manage/mechHarvest_edit_form.jsx